"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AuthLayout = (props) => {
    return (react_1.default.createElement("div", { className: "min-h-screen bg-white" }, props.children));
};
exports.default = AuthLayout;
